module.exports = __webpack_public_path__ + "static/media/close-icon-restaurant.eff819b2.svg";